import { render, staticRenderFns } from "./localChainlist.vue?vue&type=template&id=bfab5262&"
import script from "./localChainlist.vue?vue&type=script&lang=js&"
export * from "./localChainlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports